import { render, staticRenderFns } from "./SubscriptionsList.vue?vue&type=template&id=44b0945d&scoped=true"
import script from "./SubscriptionsList.vue?vue&type=script&lang=js"
export * from "./SubscriptionsList.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsList.vue?vue&type=style&index=0&id=44b0945d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b0945d",
  null
  
)

export default component.exports